import { toRequest } from '../../utils/RequestUtils';
import { getApis } from './../../library/Apis';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_DISTRATO,
  CONTRATO_VERSAO_DISTRATO_NAME,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_CONTRATO_NAME,
} from '../../library/ContratoVersoes';

export const CLEARED_ALL_TEMPLATES_ACTION = 'CLEARED_ALL_TEMPLATES_ACTION';
export const LOADED_TEMPLATES_ACTION = 'LOADED_TEMPLATES_ACTION';
export const LOADED_TEMPLATE_ACTION = 'LOADED_TEMPLATE_ACTION';
export const LOADING_MACROS_POR_TEMPLATE_ACTION =
  'LOADING_MACROS_POR_TEMPLATE_ACTION';
export const LOADED_MACROS_POR_TEMPLATE_ACTION =
  'LOADED_MACROS_POR_TEMPLATE_ACTION';
export const CLEARED_CONTRATOS_PAGE_ACTION = 'CLEARED_CONTRATOS_PAGE_ACTION';
export const LOADED_CONTRATOS_PAGE_ACTION = 'LOADED_CONTRATOS_PAGE_ACTION';
export const CLEARED_COOPERATIVA_BY_COD_ACTION =
  'CLEARED_COOPERATIVA_BY_COD_ACTION';
export const LOADING_COOPERATIVA_BY_COD_ACTION =
  'LOADING_COOPERATIVA_BY_COD_ACTION';
export const LOADED_COOPERATIVA_BY_COD_ACTION =
  'LOADED_COOPERATIVA_BY_COD_ACTION';
export const LOADING_CONTRATO_ANALISE_OPERACIONAL =
  'LOADING_CONTRATO_ANALISE_OPERACIONAL';
export const LOADED_CONTRATO_ANALISE_OPERACIONAL =
  'LOADED_CONTRATO_ANALISE_OPERACIONAL';
export const LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION =
  'LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION';
export const LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION =
  'LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION';
export const DOWNLOADING_CONTRATO_ARQUIVO_AUXILIAR_ACTION =
  'DOWNLOADING_CONTRATO_ARQUIVO_AUXILIAR_ACTION';
export const LOADING_ALL_FLUXO_TIPOS = 'LOADING_ALL_FLUXO_TIPOS';
export const LOADED_ALL_FLUXO_TIPOS = 'LOADED_ALL_FLUXO_TIPOS';
export const LOADING_ALL_CONTRATO_TIPOS = 'LOADING_ALL_CONTRATO_TIPOS';
export const LOADED_ALL_CONTRATO_TIPOS = 'LOADED_ALL_CONTRATO_TIPOS';

const getEndpoint = (version) => {
  return getApis().apis.contrato + 'v' + version;
};

export const clearAllTemplates = () => ({
  type: CLEARED_ALL_TEMPLATES_ACTION,
  payload: null,
});

export const loadAllTemplates = (callbackSuccess, callbackError) => {
  return (dispatch) => {
    toRequest(
      'get',
      [getEndpoint(1) + '/template'],
      'contratoTemplates'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_TEMPLATES_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadTemplateById = (id, callbackSuccess, callbackError) => {
  return (dispatch) => {
    toRequest(
      'get',
      [`${getEndpoint(1)}/template/${id}`],
      'contratoTemplate'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_TEMPLATE_ACTION,
          payload: {
            ...resp.data,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadMacrosPorTemplate = (
  templateId,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_MACROS_POR_TEMPLATE_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [`${getEndpoint(1)}/macro/template/${templateId}`],
      'contratoMacrosPorTemplate'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_MACROS_POR_TEMPLATE_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_MACROS_POR_TEMPLATE_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_MACROS_POR_TEMPLATE_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const saveTemplate = (template, callbackSuccess, callbackError) => {
  return () => {
    toRequest(
      'put',
      [
        `${getEndpoint(1)}/template/${template.id}`,
        {
          htmlTemplate: template.htmlTemplate,
        },
      ],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearContratosPageList = () => ({
  type: CLEARED_CONTRATOS_PAGE_ACTION,
  payload: null,
});

export const loadContratosPaginado = (
  busca,
  filters,
  page,
  size,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    let filterQuery = `?page=${page}`;
    filterQuery = filterQuery + `&size=${size}`;

    let request = {
      ...filters,
      filtro: busca,
    };

    let i;
    let requestValue;

    for (i in request) {
      requestValue = request[i];
      if (typeof requestValue === 'string' && requestValue === '') {
        delete request[i];
      }
    }

    toRequest(
      'post',
      [`${getEndpoint(1)}/contrato/page${filterQuery}`, request],
      'contratosPaginado'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATOS_PAGE_ACTION,
          payload: {
            ...resp.data,
            busca,
            filters: filters,
            page,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearCooperativaByCod = () => ({
  type: CLEARED_COOPERATIVA_BY_COD_ACTION,
  payload: null,
});

export const loadCooperativaByCod = (
  codCoop,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_COOPERATIVA_BY_COD_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [`${getEndpoint(1)}/cooperativa/${codCoop}`],
      'cooperativaByCod'
    ).then(
      (resp) => {
        dispatch({
          type: LOADING_COOPERATIVA_BY_COD_ACTION,
          payload: false,
        });
        dispatch({
          type: LOADED_COOPERATIVA_BY_COD_ACTION,
          payload: {
            ...resp.data,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_COOPERATIVA_BY_COD_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadContratoAnaliseOperacional = (
  id,
  tipoContrato,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_ANALISE_OPERACIONAL,
      payload: {
        tipoContrato: tipoContrato,
        loading: true,
      },
    });
    toRequest(
      'get',
      [`${getEndpoint(1)}/contrato/contrato-html/${id}/${versaoContrato}`],
      'templateAnaliseOperacional'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATO_ANALISE_OPERACIONAL,
          payload: {
            tipoContrato: tipoContrato,
            template: resp.data,
          },
        });
        dispatch({
          type: LOADING_CONTRATO_ANALISE_OPERACIONAL,
          payload: {
            tipoContrato: tipoContrato,
            loading: false,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_ANALISE_OPERACIONAL,
          payload: {
            tipoContrato: tipoContrato,
            loading: false,
          },
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadContratoArquivosAuxiliares = (
  tipoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [`${getEndpoint(1)}/documento/auxiliar?tipoContrato=${tipoContrato}`],
      'contratoDocumentosAuxiliares'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
          payload: resp.data || [],
        });
        dispatch({
          type: LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadContratoArquivosAuxiliaresDescentralizados = (
  tipoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [
        `${getEndpoint(
          1
        )}/documento/auxiliar?tipoFluxo=DESCENTRALIZADO&tipoContrato=${tipoContrato}`,
      ],
      'contratoDocumentosAuxiliares'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
          payload: resp.data || [],
        });
        dispatch({
          type: LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_ARQUIVOS_AUXILIARES_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};


export const downloadContratoDocumentoAuxiliar = (
  idDocumento,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: DOWNLOADING_CONTRATO_ARQUIVO_AUXILIAR_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [
        `${getEndpoint(1)}/documento/auxiliar/${idDocumento}`,
        {
          onDownloadProgress: ({ total, loaded }) => {
            if (typeof callbackProgress === 'function') {
              const percent = loaded / total;
              callbackProgress(percent);
            }
          },
          responseType: 'arraybuffer',
          headers: {
            // 'Accept': 'text/csv',
            'Access-Control-Allow-Headers':
              'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          },
        },
      ],
      'download-contrato'
    ).then(
      (resp) => {
        dispatch({
          type: DOWNLOADING_CONTRATO_ARQUIVO_AUXILIAR_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: DOWNLOADING_CONTRATO_ARQUIVO_AUXILIAR_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const downloadContratoDocumentoAuxiliarDescentralizado = (
  idDocumento,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: DOWNLOADING_CONTRATO_ARQUIVO_AUXILIAR_ACTION,
      payload: true,
    });
    toRequest(
      'get',
      [
        `${getEndpoint(1)}/documento/auxiliar/descentralizado/${idDocumento}`,
        {
          onDownloadProgress: ({ total, loaded }) => {
            if (typeof callbackProgress === 'function') {
              const percent = loaded / total;
              callbackProgress(percent);
            }
          },
          responseType: 'arraybuffer',
          headers: {
            // 'Accept': 'text/csv',
            'Access-Control-Allow-Headers':
              'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          },
        },
      ],
      'download-contrato'
    ).then(
      (resp) => {
        dispatch({
          type: DOWNLOADING_CONTRATO_ARQUIVO_AUXILIAR_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: DOWNLOADING_CONTRATO_ARQUIVO_AUXILIAR_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAllFluxoTipos = (callbackSuccess, callbackError) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_ALL_CONTRATO_TIPOS,
      payload: {
        loading: true,
      },
    });
    toRequest(
      'get',
      [`${getEndpoint(1)}/contrato/tiposFluxos`],
      'allFluxoTipos'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ALL_FLUXO_TIPOS,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ALL_FLUXO_TIPOS,
          payload: {
            loading: false,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ALL_FLUXO_TIPOS,
          payload: {
            loading: false,
          },
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadAllContratoTipos = (callbackSuccess, callbackError) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_ALL_CONTRATO_TIPOS,
      payload: {
        loading: true,
      },
    });
    toRequest(
      'get',
      [`${getEndpoint(1)}/contrato/tiposContratos`],
      'allContratoTipos'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_ALL_CONTRATO_TIPOS,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_ALL_CONTRATO_TIPOS,
          payload: {
            loading: false,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ALL_CONTRATO_TIPOS,
          payload: {
            loading: false,
          },
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const downloadDocumentoById = (
  idDocumento,
  contentType,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return () => {
    toRequest(
      'get',
      [
        `${getEndpoint(1)}/documento/pdf/${idDocumento}`,
        {
          onDownloadProgress: (event) => {
            if (typeof callbackProgress === 'function') {
              callbackProgress(event);
            }
          },
          responseType: 'arraybuffer',
          headers: {
            Accept: contentType,
            'Access-Control-Allow-Headers':
              'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          },
        },
      ],
      'download-material-pedagogico'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const downloadContratoByIdContratoVersaoContrato = (
  idContrato,
  versaoContrato,
  contentType,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return () => {
    toRequest(
      'get',
      [
        `${getEndpoint(
          1
        )}/documento/planotrabalho/pdf/${idContrato}/${versaoContrato}`,
        {
          onDownloadProgress: (event) => {
            if (typeof callbackProgress === 'function') {
              callbackProgress(event);
            }
          },
          responseType: 'arraybuffer',
          headers: {
            Accept: contentType,
            'Access-Control-Allow-Headers':
              'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          },
        },
      ],
      'download-material-pedagogico'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const downloadContrato = (
  params,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  const fileName = params.fileName;
  const contentType = params.contentType;

  toRequest(
    'get',
    [
      `${getEndpoint(1)}/documento?filename=${fileName}`,
      {
        onDownloadProgress: ({ total, loaded }) => {
          if (typeof callbackProgress === 'function') {
            const percent = loaded / total;
            callbackProgress(percent);
          }
        },
        responseType: 'arraybuffer',
        headers: {
          Accept: contentType,
          'Access-Control-Allow-Headers':
            'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
        },
      },
    ],
    'download'
  ).then(
    (resp) => {
      if (typeof callbackProgress === 'function') {
        callbackProgress(1);
      }
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(resp);
      }
    },
    (error) => {
      if (typeof callbackError === 'function') {
        callbackError(error);
      }
    }
  );
};


export const loadContratoArquivos = (
  idContrato,
  loadingType,
  loadedType,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: loadingType,
      payload: true,
    });
    toRequest(
      'get',
      [`${getEndpoint(1)}/contrato/listar-adendos/${idContrato}`],
      'listaContratoArquivos'
    ).then(
      (resp) => {
        dispatch({
          type: loadedType,
          payload: resp.data,
        });
        dispatch({
          type: loadingType,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: loadingType,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoAlteraStatus = (
  id,
  versaoContrato,
  loadingType,
  loadedType,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: loadingType,
      payload: true,
    });
    toRequest(
      'put',
      [`${getEndpoint(1)}/contrato/status/${id}/${versaoContrato}`],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: loadedType,
          payload: resp.data,
        });
        dispatch({
          type: loadingType,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: loadingType,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const uploadContrato = (
  file,
  id,
  versaoContrato,
  callbackSuccess,
  callbackError,
  callbackProgress
) => {
  return () => {
    let url = `${getEndpoint(1)}/documento/`;
    switch (versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        url = url + CONTRATO_VERSAO_ADITIVO_NAME;
        break;
      case CONTRATO_VERSAO_DISTRATO:
        url = url + CONTRATO_VERSAO_DISTRATO_NAME;
        break;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        url = url + CONTRATO_VERSAO_CONTRATO_NAME;
        break;
    }
    url = url + '/' + id;
    let data = new FormData();
    data.append('file', file);
    toRequest(
      'post',
      [
        url,
        data,
        {
          headers: {
            'content-type':
              'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
          },
          onUploadProgress: ({ total, loaded }) => {
            const percent = loaded / total;
            callbackProgress({ percent }, file);
          },
        },
      ],
      'save'
    ).then(
      (resp) => {
        callbackSuccess(resp, file);
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
